import React, { useState, useEffect } from 'react';

export const ImageSlider = () => {
  const images = [
    'https://customer-assets.emergentagent.com/job_weddingbliss-9/artifacts/f6fg9i5r_1.JPG',
    'https://customer-assets.emergentagent.com/job_weddingbliss-9/artifacts/zq5a2lbz_2.JPG',
    'https://customer-assets.emergentagent.com/job_weddingbliss-9/artifacts/3mgkq6wd_3.jpg',
    'https://customer-assets.emergentagent.com/job_weddingbliss-9/artifacts/6x2si94p_4.jpg',
    'https://customer-assets.emergentagent.com/job_weddingbliss-9/artifacts/coj6p2j8_5.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/c55flasb_6.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/b26mtdf6_7.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/458x5we1_8.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/3206iwq6_9.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/ijcokjac_10.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/33h4z3yb_11.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/d6dxs45n_12.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/nbteg421_13.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/20ncdokj_14.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/7538q5c1_15.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/ethe8wcu_16.jpg',
    'https://customer-assets.emergentagent.com/job_weddingslider/artifacts/k59okox6_17.jpg'
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="relative w-80 h-80 mx-auto rounded-3xl overflow-hidden shadow-2xl">
      {images.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
            index === currentIndex 
              ? 'opacity-100 scale-100' 
              : 'opacity-0 scale-105'
          }`}
        >
          <img
            src={image}
            alt={`Couple photo ${index + 1}`}
            className="w-full h-full object-cover"
          />
        </div>
      ))}
      
      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
      
      {/* Dots indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {images.map((_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentIndex 
                ? 'bg-white scale-125' 
                : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};